import React, { useEffect, useState } from "react";
import {
  Format,
  ListBuilder,
  ActionBar,
  FormBuilder,
  usePreferences,
} from "@redriver/cinnamon";
import { getSchedules } from "./actions";
import { TablePagination } from "components/pagination";
import { Link } from "react-router-dom";
import { ScheduleRoutes } from "constants/routes";
import { SchedulesFilters, SchedulesFilterDisplay } from ".";
import { ContentPanel } from "components/displays";
import {
  TableConfigurator,
  ConfigurableTable,
} from "features/CustomConfig/TableConfig";
import { TextSearch } from "features/../../../shared/components/search";
const SchedulesList = () => {
  const { preferences } = usePreferences();
  const [config, setConfig] = useState(preferences.scheduleTableConfig);
  const [pageSizeConfig, setPageSizeConfig] = useState(
    preferences.customerTableConfigPageSize
      ? preferences.customerTableConfigPageSize
      : 25
  );

  useEffect(() => {
    setConfig(preferences.scheduleTableConfig);
  }, [preferences.scheduleTableConfig]);

  useEffect(() => {
    preferences.scheduleTableConfigPageSize &&
      setPageSizeConfig(preferences.scheduleTableConfigPageSize);
  }, [preferences.scheduleTableConfigPageSize]);

  const columns = [
    {
      field: "scheduleNumber",
      title: "Customer Schedule Number",
      render: (schedule) => (
        <Link
          to={ScheduleRoutes.Schedule(schedule.scheduleId)}
          className="schedule-link"
        >
          {schedule.scheduleNumber}
        </Link>
      ),
    },
    { field: "clientName", title: "Customer" },
    { field: "customerID", title: "Customer ID", sortable: false },
    {
      field: "startDate",
      title: "Schedule Start Date",
      render: (x) => <Format.Date value={x.startDate} format="DD MMM YYYY" />,
    },
    { field: "status", title: "Status" },
    { field: "agreementNumber", title: "Master Number" },
    { field: "supplierNo", title: "Supplier No", sortable: false },
    { field: "supplier", title: "Supplier", sortable: false },
    { field: "officeName", title: "Office" },
    { field: "accountManager", title: "Account Manager", sortable: false },
  ];

  return (
    <React.Fragment>
      <ListBuilder
        withTable
        initialPagination={{ pageSize: pageSizeConfig, pageNumber: 1 }}
        loadAction={getSchedules}
        dataTransform={(data) => data.results}
        totalTransform={(data) => data.totalResults}
        loadParams={{ pageSize: pageSizeConfig }}
        renderList={(tableProps, state, events) => (
          <div>
            <ContentPanel
              title="Schedules"
              wrapperCssClass="outline-grid schedules-list"
              headerCssClass="defaults-page-title"
              headerContent={
                <FilterBar
                  state={state}
                  events={events}
                  config={config}
                  columns={columns}
                  initialPageSize={25}
                  pageSizeConfig={pageSizeConfig}
                ></FilterBar>
              }
            >
              <div className="spaced">
                <ConfigurableTable
                  state={state}
                  events={events}
                  tableProps={tableProps}
                  emptyMessage="No schedules found"
                  columns={columns}
                  config={config}
                />
                <div className="padded">
                  <TablePagination
                    pageSize={pageSizeConfig}
                    pageNumber={state.pagination.pageNumber}
                    onChange={events.onChangePagination}
                    totalItems={state.total}
                  />
                </div>
              </div>
            </ContentPanel>
          </div>
        )}
      />
    </React.Fragment>
  );
};

const FilterBar = ({
  state,
  events,
  config,
  columns,
  initialPageSize,
  pageSizeConfig,
}) => (
  <FormBuilder
    value={state.filters}
    onChange={events.onChangeFilters}
    renderForm={(formProps) => (
      <ActionBar className="filter-display">
        <ActionBar.Item>
          <TextSearch
            filters={state.filters}
            onChange={events.onChangeFilters}
          ></TextSearch>
        </ActionBar.Item>
        <ActionBar.Space />
        <ActionBar.Item className="search-filter-display">
          <SchedulesFilterDisplay
            filters={state.filters}
            onChange={events.onChangeFilters}
          />
        </ActionBar.Item>
        <ActionBar.Item fluid></ActionBar.Item>
        <ActionBar.Space />
        <ActionBar.Item>
          <TableConfigurator
            config={config}
            columns={columns}
            configId="scheduleTableConfig"
            titlePreFix="Schedules"
            initialPageSize={initialPageSize}
            pageSizeConfig={pageSizeConfig}
          ></TableConfigurator>
        </ActionBar.Item>
        <ActionBar.Space />
        <ActionBar.Item>
          <SchedulesFilters
            title="Filters"
            filters={state.filters}
            onChange={events.onChangeFilters}
            formProps={formProps}
            onReset={events.onReset}
          />
        </ActionBar.Item>
      </ActionBar>
    )}
  />
);

export default SchedulesList;
